var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "PostalNumber",
      class: { isPc: !_vm.isSp, hasError: _vm.hasError },
    },
    [
      _c(
        "div",
        { staticClass: "inputWithLabel", class: { isPc: !_vm.isSp } },
        [
          _c(
            "InputLabel",
            {
              staticClass: "labelArea",
              class: {
                isPc: !_vm.isSp,
                isHasLabel: !_vm.isSp && (_vm.required || _vm.optional),
              },
              attrs: { required: _vm.required, optional: _vm.optional },
            },
            [_vm._v("\n      郵便番号\n    ")]
          ),
          _vm._v(" "),
          _c("InputItem", {
            staticClass: "inputItem",
            class: { hasError: _vm.hasError, isPc: !_vm.isSp },
            attrs: {
              "input-type": "text",
              "placeholder-value": "例）1234567（ハイフンなし）",
              disabled: _vm.disabled,
            },
            on: { blur: _vm.onBlur, focus: _vm.onFocus, input: _vm.onInput },
            model: {
              value: _vm.handleInputValue,
              callback: function ($$v) {
                _vm.handleInputValue = $$v
              },
              expression: "handleInputValue",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "underInputArea", class: { isPc: !_vm.isSp } },
        [
          _c("SuggestList", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isDisplaySuggest && _vm.suggestList.address.length !== 0,
                expression:
                  "isDisplaySuggest && suggestList.address.length !== 0",
              },
            ],
            staticClass: "suggestArea",
            class: { isPc: !_vm.isSp },
            attrs: { list: _vm.arrangedSuggestList, dense: "" },
            on: { onClick: _vm.onClick },
          }),
          _vm._v(" "),
          _c("PartialErrorMessage", {
            staticClass: "partialErrorComponent",
            attrs: { "is-sp-flg": true, error: _vm.displayError },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }